<template>
  <div>
    <TextFormGroup
        v-model="data.headline"
        name="headline"
        label="Headline"
        :error="(errors.headline || [])[0]"
    />

    <TextareaFormGroup
        v-model="data.text"
        name="text"
        label="Text"
        :error="(errors.text || [])[0]"
    />

    <NumberFormGroup
        v-model="data.limit"
        name="limit"
        label="Limit"
        :error="(errors.limit || [])[0]"
    />
  </div>
</template>

<script>
import NumberFormGroup from '@/vendor/forms/FormGroups/Horizontal/Number'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'
import TextareaFormGroup from '@/vendor/forms/FormGroups/Horizontal/Textarea'

export default {
  components: {NumberFormGroup,TextFormGroup,TextareaFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    }
  },

  computed: {
    data: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
